// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MehTwoToneSvg from "@fishx/icons-svg/es/asn/MehTwoTone";
import FishxIcon from '../components/FishxIcon';

var MehTwoTone = function MehTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MehTwoToneSvg
  }));
};

MehTwoTone.displayName = 'MehTwoTone';
export default React.forwardRef(MehTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MehTwoTone.js
// module id = 3116
// module chunks = 0